module.exports = __webpack_public_path__ + "static/media/logo_sbwallet.bca057bb.jpg";